import React, { useState, useEffect } from "react";
import axios from "axios";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import { ChallanList } from "../Challan/ChallanList";
import { BillList } from "../Bill/BillList";
import classNames from "classnames";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Slide,
  Tab,
  Tabs,
  TextField,
} from "@material-ui/core";
import CustomInput from "../../components/CustomInput/CustomInput";
import IconButton from "@material-ui/core/IconButton";
// import FilterListIcon from "@material-ui/icons/FilterList";
import CardBody from "../../components/Card/CardBody";
import styles from "../../assets/jss/material-dashboard-react/components/customTabsStyle";
// import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import { FilterDialog } from "../../components/common/FilterDialog";
import {
  GetAllAccountsAPI,
  GetBulkReadyMasterRangeAPI,
  GetAllBrandsAPI,
  GetAllReadyMastersAPI,
  GetStockReportAPI,
} from "../../config/api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ChallanListCredit } from "../Challan/ChallanListCredit";
import { Search, FilterList as FilterIcon } from "@material-ui/icons";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import Autocomplete from "@mui/material/Autocomplete";
import { StockList } from "./StockList";
import StockListPageM from "../../assets/html/StockListPageM";
import { dataURItoBlob, htmlTemplateToDataString } from "../../utils";
import PrintIcon from "@mui/icons-material/Print";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import _ from "lodash";

const tabs = [
  {
    tabName: "Challans",
    tabIcon: BugReport,
    tabContent: <ChallanListCredit />,
  },
];

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Test(props) {
  const [brands, setBrands] = useState([]);
  const [value, setValue] = useState(0);
  const authToken = useSelector((state) => state.userReducer.authToken);
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const [product, setProduct] = useState("");
  const [brand, setBrand] = useState("");
  const [category, setCategory] = useState("");
  const [colorCode, setColorCode] = useState('');
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [party, setParty] = useState([]);
  const [dataaa, setDataaa] = useState([]);
  console.log(dataaa, "<<<<<<<83dataaa")
  const [tota, setTota] = useState(0);
  const [dataToPass, setDatatoPass] = useState({});

  const [openFilter, setOpenFilter] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleOpenFilter = () => setOpenFilter(true);
  const handleCloseFilter = () => setOpenFilter(false);

  function handleApplyFilter(dataaa, startDate, endDate) {
    // Convert start and end dates to Date objects
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    console.log(dataaa, startDate, endDate, "<<<<<97");

    // Filter the array based on whether each date's `createdAt` falls within the range
    const filDataaa = dataaa.filter((item) => {
      const dbDate = new Date(item.createdAt); // Access the `createdAt` field
      console.log("Checking:", dbDate);
      return !isNaN(dbDate) && dbDate >= startDate && dbDate <= endDate;
    });
    // Log and return filtered dataaa
    console.log("Filtered Accounts:", filDataaa);
    // Update the dataaa with the filtered list, close the modal, and update total count
    setDataaa(filDataaa);
    setOpenFilter(false); // Close the modal
  }

  const classes = useStyles();
  const { rtlActive } = props;
  const cardTitle = classNames({
    [classes.cardTitle]: true,
    [classes.cardTitleRTL]: rtlActive,
  });
  const [readyMasterRange, setReadyMasterRange] = useState([]);
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 500,
  });

  function getAllThings() {
    Promise.all([
      axios.get(GetAllAccountsAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
      axios.get(GetBulkReadyMasterRangeAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
      axios.get(GetAllBrandsAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }),
    ])
      .then((responses) => {
        const [accountsResponse, readyMasterRangeResponse, brands] = responses;

        // Handle accounts data
        const accountsData = accountsResponse.data.accounts;
        setAccounts(accountsData);
        const partyData = accountsData.map((account) => account.name);
        setParty(partyData);

        // Handle readyMasterRange data
        const readyMasterRangeData =
          readyMasterRangeResponse.data.readyMasterRange;
        setReadyMasterRange(readyMasterRangeData);

        //HAndle brands

        const brandsData = brands.data.brandMasters;
        setBrands(brandsData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        toast.error("Something went wrong, Please Contact Admin", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  }

  useEffect(() => {
    getAllThings();
  }, [authToken, userInfo.entity]);

  const handleChange = (event, value) => {
    setValue(value);
  };

  const handleCloseFilterModal = () => {
    setOpenFilter(false);
  };

  function handleSearch() {
    setDatatoPass({
      category: category,
      brand: brand,
      product: product,
      colorCode: colorCode,
    });
  }

  async function _onPreview(startDate, endDate) {
    try {
      const getSideFromCode = (code) => {
        if (!code) return "";
        const str = String(code).trim();
        // Grab last alphabetic char in the string (ignores trailing digits/symbols)
        const match = str.match(/([A-Za-z])(?!.*[A-Za-z])/);
        if (!match) return "";
        const last = match[1].toUpperCase();
        if (last === "R") return "R";
        if (last === "L") return "L";
        // if (last === "B") return "B";
        return "";
      };

      const doc = new jsPDF();

      if (dataaa.length === 0) {
        doc.text("No product data available.", 10, 10);
        const pdfBlob = doc.output("blob");
        const url = window.URL.createObjectURL(pdfBlob);
        window.open(url, "_blank");
        return;
      }

      const title = "Stock Report";
      const TITLE_FONT_SIZE = 12;
      doc.setFontSize(TITLE_FONT_SIZE);
      const titleWidth = (doc.getStringUnitWidth(title) * TITLE_FONT_SIZE) / doc.internal.scaleFactor;
      const titleXPosition = (doc.internal.pageSize.getWidth() - titleWidth) / 2;
      doc.text(title, titleXPosition, 8);

      // Layout constants - minimized margins and spacing for maximum paper usage
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const leftMargin = 5;
      const rightMargin = 5;
      const topMargin = 12;
      const bottomMargin = 5;
      const colGap = 3; // minimal gap between columns
      const colWidth = (pageWidth - leftMargin - rightMargin - colGap) / 2;
      const PRODUCT_FONT_SIZE = 8;
      const TABLE_FONT_SIZE = 6;
      const HEADER_FONT_SIZE = 6;
      const productTitleYOffset = 2;
      const productSectionGap = 2;

      // Flatten all items while keeping track of product names and derived side (only R/L at end of code)
      const allItems = dataaa.map(item => {
        const sideVal = getSideFromCode(item.productCode);
        return {
          ...item,
          productName: item.productName || '',
          side: sideVal
        };
      });

      const hasSideColumn = allItems.some((it) => it.side === "R" || it.side === "L");

      const leftTitleX = leftMargin;
      const rightTitleX = leftMargin + colWidth + colGap;
      let itemIndex = 0;

      const makeTableData = (arr, startSeq = 1) =>
        arr.map((item, idx) => {
          const base = [
            startSeq + idx,
            item.sph,
            item.cyl,
            item.axis,
            item.addition,
            item.threshold,
            item.quantity,
            item.threshold - item.quantity,
          ];
          if (hasSideColumn) {
            base.push(item.side || "");
          }
          return base;
        });

      const printProductSection = (items, columnX, startY, isLeft, startSeq = 1, pageW = pageWidth) => {
        if (items.length === 0) return { endY: startY, nextSeq: startSeq };

        let yPos = startY;
        let currentProductName = '';
        let productItems = [];
        console.log(items, "<<<<<260");
        let currentSeq = startSeq;

        items.forEach((item, idx) => {
          const isNewProduct = item.productName !== currentProductName && item.productName !== '';

          // If new product and we have previous product items, print them
          if (isNewProduct && productItems.length > 0) {
            // Print product name
            if (currentProductName) {
              doc.setFontSize(PRODUCT_FONT_SIZE);
              doc.text(currentProductName, columnX, yPos);
              yPos += productTitleYOffset;
            }

            // Print table for previous product
            const headRow = ["Serial No.", "SPH", "CYL", "AXIS", "Addn", "Thrshld", "Stck", isLeft ? "Order Qty" : "Ordr Qty"];
            if (hasSideColumn) headRow.push("Side");

            const columnStyles = {
              0: { cellWidth: 10, halign: 'center' }, // Serial No.
              1: { cellWidth: 11, halign: 'center' }, // SPH
              2: { cellWidth: 11, halign: 'center' }, // CYL
              3: { cellWidth: 11, halign: 'center' }, // AXIS
              4: { cellWidth: 9, halign: 'center' }, // Addn
              5: { cellWidth: 11, halign: 'center' }, // Thrshld
              6: { cellWidth: 9, halign: 'center' }, // Stck
              7: { cellWidth: 11, halign: 'center' }, // Order Qty
            };
            if (hasSideColumn) {
              columnStyles[8] = { cellWidth: 11, halign: 'center' }; // Side
            }

            doc.autoTable({
              head: [headRow],
              body: makeTableData(productItems, currentSeq - productItems.length),
              startY: yPos,
              startX: columnX,
              margin: { left: columnX, right: pageW - columnX - colWidth, top: 0, bottom: 0 },
              tableWidth: colWidth,
              columnStyles,
              styles: {
                fontSize: TABLE_FONT_SIZE,
                cellPadding: 0.3,
                textColor: [0, 0, 0],
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
                fillColor: [255, 255, 255],
                halign: 'center',
                valign: 'middle',
              },
              headStyles: {
                fontStyle: "bold",
                fillColor: [220, 220, 220],
                textColor: [0, 0, 0],
                valign: "middle",
                halign: "center",
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
                fontSize: HEADER_FONT_SIZE,
              },
              theme: "grid",
              didDrawPage: (data) => { },
            });
            yPos = doc.autoTable.previous.finalY + productSectionGap;
            productItems = [];
          }

          // Update current product
          if (isNewProduct) {
            currentProductName = item.productName;
          }

          productItems.push(item);
          currentSeq++;
        });

        // Print last product
        if (productItems.length > 0) {
          if (currentProductName) {
            doc.setFontSize(PRODUCT_FONT_SIZE);
            doc.text(currentProductName, columnX, yPos);
            yPos += productTitleYOffset;
          }

          const headRow = ["Serial No.", "SPH", "CYL", "AXIS", "Addn", "Thrshld", "Stck", isLeft ? "Order Qty" : "Ordr Qty"];
          if (hasSideColumn) headRow.push("Side");

          const columnStyles = {
            0: { cellWidth: 8, halign: 'center' }, // Sequence number
            1: { cellWidth: 12, halign: 'center' }, // SPH
            2: { cellWidth: 12, halign: 'center' }, // CYL
            3: { cellWidth: 12, halign: 'center' }, // AXIS
            4: { cellWidth: 10, halign: 'center' }, // Addn
            5: { cellWidth: 12, halign: 'center' }, // Thrshld
            6: { cellWidth: 10, halign: 'center' }, // Stck
            7: { cellWidth: 12, halign: 'center' }, // Order Qty
          };
          if (hasSideColumn) {
            columnStyles[8] = { cellWidth: 11, halign: 'center' }; // Side
          }

          doc.autoTable({
            head: [headRow],
            body: makeTableData(productItems, currentSeq - productItems.length),
            startY: yPos,
            startX: columnX,
            margin: { left: columnX, right: pageWidth - columnX - colWidth, top: 0, bottom: 0 },
            tableWidth: colWidth,
            columnStyles,
            styles: {
              fontSize: TABLE_FONT_SIZE,
              cellPadding: 0.3,
              textColor: [0, 0, 0],
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              halign: 'center',
              valign: 'middle',
            },
            headStyles: {
              fontStyle: "bold",
              fillColor: [220, 220, 220],
              textColor: [0, 0, 0],
              valign: "middle",
              halign: "center",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              fontSize: HEADER_FONT_SIZE,
            },
            theme: "grid",
            didDrawPage: (data) => { },
          });
          yPos = doc.autoTable.previous.finalY;
        }

        return { endY: yPos, nextSeq: currentSeq };
      };

      // Helper function to estimate space needed for items
      const estimateSpace = (items, startY) => {
        if (items.length === 0) return startY;

        let estimatedY = startY;
        let currentProductName = '';
        let productCount = 0;

        items.forEach(item => {
          const isNewProduct = item.productName !== currentProductName && item.productName !== '';
          if (isNewProduct) {
            if (currentProductName) {
              // Add space for previous product: header + table header + rows
              estimatedY += PRODUCT_FONT_SIZE / 2 + productTitleYOffset; // Product name
              estimatedY += 4; // Table header
              estimatedY += productCount * 3.5; // Rows
              estimatedY += productSectionGap; // Gap between products
            }
            currentProductName = item.productName;
            productCount = 0;
          }
          productCount++;
        });

        // Add space for last product
        if (currentProductName) {
          estimatedY += PRODUCT_FONT_SIZE / 2 + productTitleYOffset; // Product name
          estimatedY += 4; // Table header
          estimatedY += productCount * 3.5; // Rows
        }

        return estimatedY;
      };

      // Textbook-style layout: Fill left column completely, then right column, then next page
      let sequenceNumber = 1;
      while (itemIndex < allItems.length) {
        // Fill left column completely first
        let leftColumnY = topMargin;
        let leftColumnItems = [];
        let leftColumnFull = false;

        while (itemIndex < allItems.length && !leftColumnFull) {
          const testItems = [...leftColumnItems, allItems[itemIndex]];
          const estimatedEndY = estimateSpace(testItems, leftColumnY);

          // Check if left column would be full
          if (estimatedEndY > pageHeight - bottomMargin) {
            leftColumnFull = true;
          } else {
            leftColumnItems.push(allItems[itemIndex]);
            itemIndex++;
          }
        }

        // Print left column
        if (leftColumnItems.length > 0) {
          const result = printProductSection(leftColumnItems, leftTitleX, leftColumnY, true, sequenceNumber, pageWidth);
          leftColumnY = result.endY;
          sequenceNumber = result.nextSeq;
        }

        // Fill right column completely
        let rightColumnY = topMargin;
        let rightColumnItems = [];
        let rightColumnFull = false;

        while (itemIndex < allItems.length && !rightColumnFull) {
          const testItems = [...rightColumnItems, allItems[itemIndex]];
          const estimatedEndY = estimateSpace(testItems, rightColumnY);

          // Check if right column would be full
          if (estimatedEndY > pageHeight - bottomMargin) {
            rightColumnFull = true;
          } else {
            rightColumnItems.push(allItems[itemIndex]);
            itemIndex++;
          }
        }

        // Print right column
        if (rightColumnItems.length > 0) {
          const result = printProductSection(rightColumnItems, rightTitleX, rightColumnY, false, sequenceNumber, pageWidth);
          rightColumnY = result.endY;
          sequenceNumber = result.nextSeq;
        }

        // Move to next page if there are more items
        if (itemIndex < allItems.length) {
          doc.addPage();
        }
      }

      const pdfBlob = doc.output("blob");
      const url = window.URL.createObjectURL(pdfBlob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  }






  return (
    <Card plain={false}>
      <CardHeader color={"rose"} plain={false}>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <div>
            {/* <Tabs
                            value={value}
                            onChange={handleChange}
                            classes={{
                                root: classes.tabsRoot,
                                indicator: classes.displayNone,
                                scrollButtons: classes.displayNone,
                            }}
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            {tabs.map((prop, key) => {
                                let icon = {};
                                if (prop.tabIcon) {
                                    icon = {
                                        icon: <prop.tabIcon />,
                                    };
                                }
                                return (
                                    <Tab
                                        classes={{
                                            root: classes.tabRootButton,
                                            selected: classes.tabSelected,
                                            wrapper: classes.tabWrapper,
                                        }}
                                        key={key}
                                        label={prop.tabName}
                                        {...icon}
                                    />
                                );
                            })}
                        </Tabs> */}
          </div>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 50,
            }}
          >
            <Autocomplete
              disablePortal
              id="category-autocomplete"
              options={["Color", "Range"]}
              fullWidth
              value={category}
              onChange={(event, value) => setCategory(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  style={{
                    backgroundColor: "#FFFFFF",
                    opacity: "50%",
                    borderRadius: 5,
                  }}
                />
              )}
            />

            {/* Conditionally render TextField for color code */}
            {category === "Color" && (
              <TextField
                label="Color Code"
                style={{
                  backgroundColor: "#FFFFFF",
                  opacity: "50%",
                  borderRadius: 5,
                }}
                value={colorCode}
                onChange={(e) => setColorCode(e.target.value)}
                fullWidth
              // style={{
              //   marginTop: '16px',
              //   backgroundColor: "#FFFFFF",
              //   borderRadius: 5,
              // }}
              />
            )}

            <Autocomplete
              id="product"
              filterOptions={filterOptions}
              loading={readyMasterRange.length === 0 ? true : false}
              className={classes.formControl}
              options={readyMasterRange}
              fullWidth
              onChange={(event, value) => {
                // Check if any product already has a discount
                setProduct(value ? value.productName : "");
              }}
              getOptionLabel={(option) => `${option.productName}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Product"
                  style={{
                    backgroundColor: "#FFFFFF",
                    opacity: "50%",
                    borderRadius: 5,
                  }}
                />
              )}
            />

            <Autocomplete
              disablePortal
              id="brand-autocomplete"
              options={brands}
              fullWidth
              onChange={(event, value) => setBrand(value ? value._id : "")}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brands"
                  style={{
                    backgroundColor: "#FFFFFF",
                    opacity: "50%",
                    borderRadius: 5,
                  }}
                />
              )}
            />
            <IconButton color={"secondary"} onClick={(e) => handleSearch()}>
              <Search />
            </IconButton>
            <IconButton color="secondary" onClick={handleOpenFilter}>
              <FilterIcon />
            </IconButton>
            <IconButton color={"secondary"} onClick={() => _onPreview()}>
              <PrintIcon />
            </IconButton>
          </Box>
        </Box>
      </CardHeader>
      <CardBody>
        <StockList
          filter={filter}
          accounts={accounts}
          readyMasterRange={readyMasterRange}
          dataToPass={dataToPass}
          setDataaa={setDataaa}
          data={dataaa}
        />
      </CardBody>
      {/* <FilterDialog
                party={party}
                filter={filter}
                setFilter={setFilter}
                showFilterDialog={openFilter}
                handleCloseFilterDialog={handleCloseFilterModal}
            /> */}
      <Dialog open={openFilter} onClose={handleCloseFilter}>
        <DialogTitle>Select Date Range</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <DatePicker
              label="Start Date"
              value={startDate}
              sx={{ paddingBottom: 2 }}
              onChange={(e) => setStartDate(e)}
              renderInput={(props) => <TextField {...props} fullWidth />}
            />
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              renderInput={(props) => <TextField {...props} fullWidth />}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            onClick={() => handleApplyFilter(dataaa, startDate, endDate)}
            color="primary"
          >
            Apply Filter
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

